
import Vue from "vue";
import CrmHistory from "@/models/crm/crm-history";
import CrmHistoryAppointment from "@/models/crm/crm-history-appointment";

export default Vue.extend({
	data() {
		return {
			date: new Date(),
			time: new Date(),
			appointment: new CrmHistoryAppointment(),
			addOnCalendar: false
		};
	},
	props: {
		event: {
			required: true,
			type: Object as () => CrmHistory
		},
	},
	computed: {
		locale(): string {
			return this.$i18n.locale;
		},
	},
	watch: {
		date: {
			immediate: true,
			handler() {
				this.appointment.TimeStamp = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(),
					this.time.getHours(), this.time.getMinutes(), this.time.getSeconds());
			}
		},
		time: {
			immediate: true,
			handler() {
				this.appointment.TimeStamp = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(),
					this.time.getHours(), this.time.getMinutes(), this.time.getSeconds());
			}
		},
		appointment: {
			immediate: true,
			handler(){
				this.event.Props = this.appointment;
			}
		},
		addOnCalendar(){
			this.$emit("toggle-calendar",this.addOnCalendar);
		}
	},
	mounted(){
		this.time = new Date();
		this.time.setHours(this.time.getHours() + 1);
		this.time.setMinutes(0);
	},
	components: {},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
